export function seededRandom(seed) {
 let value=seed>>>0;
 return ()=>{value+=0x6D2B79F5;let t=value;t=Math.imul(t^(t>>>15),t|1);t^=t+Math.imul(t^(t>>>7),t|61);return ((t^(t>>>14))>>>0)/4294967296;};
}
export function simulateCouncil({support=51,straight=100,crossover=20,popularity=0},random=Math.random) {
 const voters=1000, democrats=Math.round(voters*support/100);
 // Fixed candidate appeal profile: held constant across repeated elections.
 const appeal=[-0.8,0.4,1,-0.4,0.7,-0.1,0.6,-0.6,0.2,1,-0.9,0.4];
 const candidates=Array.from({length:12},(_,i)=>({id:i,label:`${i<6?'D':'R'}${i%6+1}`,party:i<6?'Democrat':'Republican',votes:0,tie:random()}));
 for(let voter=0;voter<voters;voter++) {
  const own=voter<democrats?0:1;
  if(random()<straight/100){for(let j=own*6;j<own*6+6;j++)candidates[j].votes++;continue;}
  const available=candidates.slice();
  for(let selection=0;selection<6;selection++) {
   const weights=available.map(c=>((c.id<6?0:1)===own?1-crossover/100:crossover/100)*Math.exp(appeal[c.id]*popularity/50));
   let target=random()*weights.reduce((a,b)=>a+b,0),index=weights.length-1;
   for(let j=0;j<weights.length;j++){target-=weights[j];if(target<0){index=j;break;}}
   available[index].votes++;available.splice(index,1);
  }
 }
 candidates.sort((a,b)=>b.votes-a.votes||a.tie-b.tie);
 return {candidates:candidates.map((c,i)=>({...c,winner:i<9})),democrats,democraticSeats:candidates.slice(0,9).filter(c=>c.party==='Democrat').length,
  cutoffTie:candidates[8].votes===candidates[9].votes};
}
